import { z } from 'zod'

/**
 * Search state for the manager's leave-request queue.
 *
 * The default view is the actionable queue. The all-requests view is the
 * audit/history surface. The `hourly` view is the Hourly Leave panel — its own
 * grant (`permission_request.*`) and its own budget, tracked separately from
 * day-based leave. All three remain linkable and survive a reload.
 */
export const leaveRequestsSearchSchema = z.object({
  view: z.enum(['pending', 'all', 'hourly']).default('pending'),
  status: z.enum(['pending', 'approved', 'rejected', 'cancelled']).optional(),
  leave_type_id: z.string().optional(),
  employee_id: z.string().optional(),
  department_id: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
})

export type LeaveRequestsSearch = z.infer<typeof leaveRequestsSearchSchema>
